import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './user-options.module.scss';
import useSession from '@/hooks/useSession';
import useLogout from '@/hooks/useLogout';
import DoorOpenIcon from '@/assets/icons/door-open-solid.svg?react';
import GearIcon from '@/assets/icons/gear.svg?react';
import { hasThreadsAccess } from '@/utils/session';
import FeedbackCTA from '@/components/FeedbackCTA';
import SettingsModal from '@/components/SettingsModal';
import { classnames } from '@/utils/functions';

const UserOptions = ({ collapsed = false }) => {
  const {
    session: { email, roles },
    pushUserEvent,
  } = useSession();

  const logout = useLogout();
  const navigate = useNavigate();
  const [showSettings, setShowSettings] = useState(false);
  const settingsButtonRef = useRef<HTMLButtonElement>(null);

  const closeSettings = () => {
    setShowSettings(false);
    settingsButtonRef.current?.focus();
  };

  const handleLogOut = async () => {
    await logout();

    navigate('/');
    window.location.reload();
  };
  return (
    <div
      className={classnames(styles['user-options'], {
        [styles['collapsed']]: collapsed,
      })}
    >
      {hasThreadsAccess(roles) && (
        <>
          <FeedbackCTA text={collapsed ? '' : 'Share Feedback'} />

          {!collapsed && (
            <div className={styles['user-details']}>
              <p className={styles['user-email']}>
                {email.split('@').map((text, index) => (
                  <span className={styles['user-email-part']} key={index}>
                    {index === 1 && '@'}
                    {text}
                  </span>
                ))}
              </p>
            </div>
          )}
        </>
      )}

      <div className={styles['actions']}>
        <button
          ref={settingsButtonRef}
          className={styles['settings']}
          aria-label="Settings"
          aria-haspopup="dialog"
          aria-expanded={showSettings}
          title="Settings"
          onClick={() => {
            setShowSettings(true);
            pushUserEvent('click_settings');
          }}
        >
          <GearIcon aria-hidden="true" />
        </button>

        <button
          className={styles['logout']}
          onClick={handleLogOut}
          aria-label={collapsed ? 'Log out' : undefined}
        >
          <DoorOpenIcon aria-hidden="true" />
          {!collapsed && 'Log out'}
        </button>
      </div>

      {showSettings && <SettingsModal onClose={closeSettings} />}
    </div>
  );
};

export default UserOptions;
